import { FauxButton } from "../../../../../core/ui";
import Heading from "../../../../../core/ui/Heading.component";

const REGULAR_COPY =
  ". To change your settings, update your account information, or cancel" +
  " your subscription at a later date, please visit our customer service section.";
const GIFT_COPY = " and the recipient will receive an email that will allow them to set up their account.";

export function CoastSuccessfullySubscribed({ isGift }: { isGift: boolean }) {
  return (
    <section className="component-pick-your-plan sign-up-step">
      <Heading level={2} className="section-title">
        You have successfully {isGift ? "gifted" : "subscribed to"} Coast Insider
      </Heading>
      <p className="section-info">
        You will receive an email with your order confirmation
        {isGift ? GIFT_COPY : REGULAR_COPY}
      </p>
      <FauxButton className="return-to-site" to="/">
        Return to Site
      </FauxButton>
    </section>
  );
}
